import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';


@customElement('specsheet-page')
export class SpecsheetPage extends LitElement {

	static styles = css`
	  :host {
		background-color: #fff;
		color: #000;
		margin-bottom: 20px;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
		page-break-after: always;
		border: 1px solid black;
		width: 100%;
		min-height: 267mm;
		// min-width: 210mm;
		display: flex;
		flex-direction: column;
	  }

	  @-moz-document url-prefix(){
		:host {
			min-height: 250mm;
			max-height: 257mm;
			page-break-after: auto;
	   }
   }

	  @media print {
		:host {
		  margin-bottom: 0;
		  width: 210mm;
		  height: 267mm;
		  border: none;
		  overflow: hidden;
		}
	  }
	`;

	render() {
		return html`
			<specsheet-head></specsheet-head>
				<slot></slot>
			<specsheet-footer></specsheet-footer>
		`;
	}
}
